module.exports = __webpack_public_path__ + "static/MaskGroup-d271d4c0ace2559870076cb9af8bd7db.jpg";